module.exports = __webpack_public_path__ + "img/TOP42023.5b90b6fd.png";